import React from 'react';

/**
 * iOS-style segmented control: a grey track with a raised pill on the active
 * segment. Used for rotation switching on hospital screens. The active label
 * takes the hospital colour so the control still carries the brand.
 */
const SegmentedControl = ({ segments, activeSegment, onChange, hospitalColor, className = '', multiRow = false }) => (
  <div className={`bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 ${className}`}>
    <div className="max-w-md mx-auto px-6 py-3">
      <div
        className={`bg-gray-100 dark:bg-gray-900 rounded-xl p-1 ${
          multiRow ? 'grid grid-cols-3 gap-1' : 'flex gap-1'
        }`}
        role="tablist"
      >
        {segments.map((segment) => {
          const isActive = activeSegment === segment.id;
          return (
            <button
              key={segment.id}
              role="tab"
              aria-selected={isActive}
              onClick={() => onChange(segment.id)}
              style={isActive && hospitalColor ? { color: hospitalColor.from } : undefined}
              className={`flex-1 min-w-0 px-3 py-2 rounded-lg text-sm transition-all duration-200 active:scale-95 flex items-center justify-center gap-1.5 ${
                isActive
                  ? 'bg-white dark:bg-gray-700 shadow-md font-bold text-gray-900 dark:!text-white animate-pop'
                  : 'font-medium text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200'
              }`}
            >
              {segment.icon && <segment.icon size={15} />}
              <span className="truncate">{segment.label}</span>
              {segment.trailingIcon && <segment.trailingIcon size={14} className="flex-shrink-0 opacity-70" />}
            </button>
          );
        })}
      </div>
    </div>
  </div>
);

export default SegmentedControl;
